module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  // Layout a page canvas on a form. TODO: parameterize; TODO: make each an immovable control that is a BackBone view 

    ; __append("\r\n<div id=\"layout-frame\" class=\"layout-frame disable-select\">\r\n	 <!-- aForm -->\r\n    <div id=\"aForm\" class=\"designer-form has-menu\" tabindex=\"1\" draggable=\"false\">\r\n    	<!-- page replaces this -->\r\n    </div>\r\n    <div id=\"pageAssets\" draggable=\"false\"></div>\r\n    <div id=\"behavior-tabs\" draggable=\"false\" ></div>\r\n</div>\r\n<div id=\"activeBehaviors\" draggable=\"false\"></div>")
  }
  return __output;

}